import type { GoogleReview } from "@/content/google-reviews";

export const FEATURED_GOOGLE_REVIEWS = [
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2s5VFpYbGxUakY0YnpsTmVtcHhRamRxZEdWdVkwRRAB",
    reviewerName: "Patel Dhairya",
    rating: 5,
    text: "Had a great experience with Earthlink. The team is very supportive and guides you clearly throughout the entire study abroad process. Their assistance with applications and visa made everything smooth and stress-free. Highly recommended!",
    publishedAt: "2026-04-29",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2tzdFkxaGlXa1JIWkdodVFqQkJOVGhGVVdSME4yYxAB",
    reviewerName: "Kajal Kharb",
    rating: 5,
    text: "I had an excellent experience with Earthlink Consultancy. The team is highly professional, supportive, and knowledgeable about the entire visa process. They guided me step-by-step, from documentation to final submission, making everything smooth and stress-free. What I liked the most is their transparency and honesty—they never made false promises and kept me updated at every stage. Thanks to their efforts, my visa process was completed successfully without any confusion.",
    publishedAt: "2026-04-30",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2t0WVNGVlpTemhUY2pkNlYwRmpMVXRIVm1OR1IwRRAB",
    reviewerName: "Darshit R Asodariya",
    rating: 5,
    text: "Very professional and knowledgeable consultant. They provided clear guidance throughout the process and were always responsive to questions. Overall, a reliable and efficient service that made everything straightforward.",
    publishedAt: "2026-06-11",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT21waGFEZDJibEZaUm0xTGVVa3RTQzAxYWxveGNFRRAB",
    reviewerName: "Manpreet Kaur",
    rating: 5,
    text: "I had an amazing experience with this UK-based company. From the first consultation, the team was professional, knowledgeable, and truly supportive. They carefully understood my academic background and career goals and guided me toward the best options for my profile. The visa process was handled with exceptional accuracy and attention to detail, giving me complete confidence at every step. They were always available, reassuring, and responsive. Thanks to their expert guidance, the entire application and visa process was smooth and stress-free. I highly recommend them!",
    publishedAt: "2025-12-30",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2taNE9HZHNTQzFmTm14MlUyVlBjRVozUTBwTWIyYxAB",
    reviewerName: "Sukh Dhillon",
    rating: 5,
    text: "Really good Service of Schengen Visa and got instant appointment. And I refer them for future Schengen Visits.",
    publishedAt: "2026-05-09",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT21ocmRFVkVUM0JaV25ZNFZWOVdXVVJyTjNacGVYYxAB",
    reviewerName: "Amal Shil",
    rating: 5,
    text: "I had an excellent experience with Earthlink Consultant. Their team is highly professional, reliable, and genuinely committed to helping students achieve their goals. From the beginning, they provided clear guidance, honest advice, and constant support throughout the entire process. What impressed me most was their transparency and dedication — they truly care about the success of the students they assist. Earthlink Consultant is definitely a very promising and trustworthy consultancy. I highly recommend them to anyone looking for dependable guidance for their future. 🌟",
    publishedAt: "2026-03-30",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2psRUxUVm5OemRLVnpKbmNWQnlXWEpLTW1ReE5WRRAB",
    reviewerName: "Krupa Barot",
    rating: 5,
    text: "We had a very good experience with Earthlink Consultancy while applying for our son’s visa. The team at Earthlink Consultancy guided us through the process clearly and professionally. They were helpful, responsive and patient with all our questions, and made the overall application process much easier and less stressful for us. We really appreciate their support and would definitely recommend Earthlink Consultancy to anyone looking for reliable assistance with visa applications. Thank you to the whole team for your help and guidance! 😊🙏",
    publishedAt: "2026-08-20",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2xnNVptMW1WbFpUUm5WMlR6aHhhRUpZZGswMFJsRRAB",
    reviewerName: "Neel Vashi",
    rating: 5,
    text: "I had an excellent experience with my student visa. They were transparent, responsive, and guided me through every step, from paperwork to interview prep, making the whole process smooth and stress-free. I highly recommend them to anyone looking for reliable and professional visa assistance.",
    publishedAt: "2025-09-30",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT21KWlJXMHdjRkJ1Ym1odWRXUjBiRW8wTUZWWk4yYxAB",
    reviewerName: "Malay MK",
    rating: 5,
    text: "Had a great experience with Earthlink Consultant. Their team was responsive, knowledgeable, and guided me clearly through the process. Communication was smooth and they answered all my questions promptly. Recommended for anyone looking for reliable consulting support.",
    publishedAt: "2026-04-29",
  },
  {
    id: "ChdDSUhNMG9nS0VJQ0FnTURJdE5peTFBRRAB",
    reviewerName: "Zeel Patel",
    rating: 5,
    text: "Incredibly grateful for earthlink consultants. Services for their exceptional support through my student file for canada. Very professional and dedicated ensuring every step was handled meticulously. I really appreciate their help with my journey. Thank you for your unwavering support, I successfully got my canadian student visa within few months. I appreciate their commitment to excellence and client satisfaction.",
    publishedAt: "2025-04-07",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT25WUGVFaEdXV3RaYVdaWVoyNW9kbHBvV0cxUmFGRRAB",
    reviewerName: "nishi delada",
    rating: 5,
    text: "I was impressed by the consultant’s professionalism. They explained everything very clearly, answered all my questions, and gave me a detailed breakdown of what I needed to do next.",
    publishedAt: "2026-04-29",
  },
  {
    id: "ChZDSUhNMG9nS0VJQ0FnTURncS02Q0lBEAE",
    reviewerName: "Smruti Malvi",
    rating: 5,
    text: "It was great experience with staff and their service. My brother has received his student Visa for UK within a week. They helped him in selecting university with his preference and helped to clear his interview. I will definitely recommend them.",
    publishedAt: "2025-02-27",
  },
  {
    id: "ChZDSUhNMG9nS0VJQ0FnSUR4ZzdHekpnEAE",
    reviewerName: "Rahul Singh",
    rating: 5,
    text: "They are best education Consultancy in the UK. They provided exceptional guidance and support throughout my academic journey. Their expertise, personalized approach, and dedication were truly commendable. Highly recommended for anyone seeking reliable assistance and valuable insights for pursuing education in the UK.",
    publishedAt: "2023-06-14",
  },
  {
    id: "ChZDSUhNMG9nS0VJQ0FnSURoOXNQaEVREAE",
    reviewerName: "Pruthviraj Thakor",
    rating: 5,
    text: "For my forthcoming trip to Europe, Earthlink Consultants UK just completed a Schengen visa application. The staff was very educated and helpful, giving me all the information and documents I needed for the visa application and assisting me in accurately filling out the papers. Also, Earthlink Consultants UK's international experts were able to inform me at every level of the application's progress. As a consequence, I received approval with no problems and am now confident and at ease about their trip.",
    publishedAt: "2023-03-08",
  },
  {
    id: "ChZDSUhNMG9nS0VJQ0FnTURnOXNtZ1dBEAE",
    reviewerName: "Manan Desai",
    rating: 5,
    text: "Earthlink Consultants are expert on their work and they did my process very smoothly, I got admission to Birmingham City University. Thanks to the supportive team they helped me on each and every step of the process",
    publishedAt: "2025-02-24",
  },
] as const satisfies readonly GoogleReview[];
